import React,{useEffect,useState} from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios';
// import { ToastContainer, toast } from 'react-toastify';
import { BASE_URL } from '../Config/Base';
import _ from 'lodash'

const TecProfilemain = () => {


  useEffect(()=>{

    document.getElementById("name").innerHTML=localStorage.getItem('username')
    document.getElementById("email").innerHTML=localStorage.getItem('email')

  });
  
  function handleSubmit(event){

    

    event.preventDefault();
    var  CurrentPassword = document.getElementById("CurrentPassword").value;
    
    var NewPassword = document.getElementById("NewPassword").value;
    const password1 = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/; 

    var Confirm = document.getElementById("Confirm").value;


    
    if(!CurrentPassword){
      document.getElementById('CurrentErr').innerHTML="Enter Current Password";
     
    }
    
    else{
     
      document.getElementById('CurrentErr').innerHTML=" ";
    }


    if(!NewPassword){
      document.getElementById('NewErr').innerHTML="Enter New Password";
      document.getElementById('NewErrA').innerHTML=" ";
      document.getElementById('NewErrB').innerHTML=" ";
    }
   
   else if (password1.test(document.getElementById('NewPassword').value)===false){
    document.getElementById('NewErrA').innerHTML="Please Enter atleast 8 characters one number,one Uppercase,one Lowercase and one Special Character";
    document.getElementById('NewErr').innerHTML=" ";
    document.getElementById('NewErrB').innerHTML=" ";
   }
   else if (NewPassword==CurrentPassword){
    document.getElementById('NewErrB').innerHTML="This is Your Current Password,Try New Password";
    document.getElementById('NewErrA').innerHTML=" ";
    document.getElementById('NewErr').innerHTML=" ";
  }

   else {
    document.getElementById('NewErrA').innerHTML=" ";
    document.getElementById('NewErr').innerHTML=" ";
    document.getElementById('NewErrB').innerHTML=" ";
   }

   if(!Confirm){
    document.getElementById('ConfirmErr').innerHTML="Re-enter Password";
    document.getElementById('ConfirmErrA').innerHTML=" ";
   }
   else if(Confirm != NewPassword){
    document.getElementById('ConfirmErrA').innerHTML="Password doesn't Match";
    document.getElementById('ConfirmErr').innerHTML=" ";
   }
   else{
    document.getElementById('ConfirmErrA').innerHTML=" ";
    document.getElementById('ConfirmErr').innerHTML=" ";
   
   }

   if(CurrentPassword && (password1.test(document.getElementById('NewPassword').value)===true) && (Confirm == NewPassword)&&(NewPassword!=CurrentPassword) ){




    //change password
 
   
 const body ={currentPassword: CurrentPassword, newPassword:NewPassword}
 let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));

 axios({
        method: "POST",
        url :`${BASE_URL}/Authenticate/ChangePassword`,
        data:body, 
        headers: {
             "Content-Type": "application/json",
             'Authorization':bearer 
         }     
     }) 
 
.then((response) =>{
 console.log(response.data);


if(response.data.status === "Error"){
    
    //  toast.error("InCorrect Password")

    setErrToast(true)
    setTimeout(() => {
      setErrToast(false)
       
     }, 3000);
    
   }

   else if(response.data.status === "Success"){

    //  toast.success("Password Change Successfully!", {
    //    position: "top-center",
    //    autoClose: 3200,
    //    hideProgressBar: false,
    //    closeOnClick: true,
    //    pauseOnHover: true,
    //    draggable: true,
    //    progress: undefined,
    //    className: 'toast-message'
    //    });
    changeformclose()
    setSuccessToast(true)

   
       setTimeout(() => {
        setSuccessToast(false)
         window.location.href="/#/"
       }, 3000);
    
    

   }
 })
 .catch(error => {
   console.log(error);
  alert("failed !")
  
 })
   

  
  

}

 
} 



function handlechange(event){

  event.preventDefault();
  var  CurrentPassword = document.getElementById("CurrentPassword").value;
  
  var NewPassword = document.getElementById("NewPassword").value;
  const password1 = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/; 

  var Confirm = document.getElementById("Confirm").value;


  
  if(!CurrentPassword){
    document.getElementById('CurrentErr').innerHTML="Enter Current Password";
   
  }
  
  else{
   
    document.getElementById('CurrentErr').innerHTML=" ";
  }


  if(!NewPassword){
    document.getElementById('NewErr').innerHTML="Enter New Password";
    document.getElementById('NewErrA').innerHTML=" ";
    document.getElementById('NewErrB').innerHTML=" ";
  }
 
 else if (password1.test(document.getElementById('NewPassword').value)===false){
  document.getElementById('NewErrA').innerHTML="Please Enter atleast 8 characters one number,one Uppercase,one Lowercase and one Special Character";
  document.getElementById('NewErr').innerHTML=" ";
  document.getElementById('NewErrB').innerHTML=" ";
 }
 else if (NewPassword==CurrentPassword){
  document.getElementById('NewErrB').innerHTML="Don't Repeat Your Current Password,try New password";
  document.getElementById('NewErrA').innerHTML=" ";
  document.getElementById('NewErr').innerHTML=" ";
}

 else{
  document.getElementById('NewErrA').innerHTML=" ";
  document.getElementById('NewErr').innerHTML=" ";
  document.getElementById('NewErrB').innerHTML=" ";
 }

 if(!Confirm){
  document.getElementById('ConfirmErr').innerHTML="Re-enter Password";
  document.getElementById('ConfirmErrA').innerHTML=" ";
 }
 else if(Confirm != NewPassword){
  document.getElementById('ConfirmErrA').innerHTML="Password doesn't Match";
  document.getElementById('ConfirmErr').innerHTML=" ";
 }
 else{
  document.getElementById('ConfirmErrA').innerHTML=" ";
  document.getElementById('ConfirmErr').innerHTML=" ";
 }
  
 
}




   
  


 /*----Function open form----*/

 function Changeformopen(event)

 {
  event.preventDefault();
    document.getElementById("modalRegisterForm").style.display = "block";

  }
  

/*----Function close form----*/

  function changeformclose()

  {

    document.getElementById("CurrentErr").innerHTML=" ";


    document.getElementById("NewErr").innerHTML="  ";  

    document.getElementById("NewErrA").innerHTML="  ";  

    document.getElementById('NewErrB').innerHTML=" ";

    document.getElementById("ConfirmErr").innerHTML="  ";  

    document.getElementById("ConfirmErrA").innerHTML="  ";

    



    document.getElementById("tecform").reset();

     document.getElementById("modalRegisterForm").style.display = "none";

   }

   //eyeicon

   function hide(){
         
    var x = document.getElementById("CurrentPassword");
  
    var eyeCurrent = document.getElementById("eyeCurrent");
    


    if(x.type === "password"){

      x.type = "text";
      eyeCurrent.classList.remove("fa-eye-slash")
      eyeCurrent.classList.add("fa-eye")
      
    }
    else{
      x.type = "password";
      eyeCurrent.classList.remove("fa-eye")
      eyeCurrent.classList.add("fa-eye-slash")
    }

  }
  

   function hideA(){

    var y = document.getElementById("NewPassword");
    var eyeNew = document.getElementById("eyeNew");

    if(y.type === "password"){

      y.type = "text";
      eyeNew.classList.remove("fa-eye-slash")
      eyeNew.classList.add("fa-eye")
      
    }
    else{
      y.type = "password";
      eyeNew.classList.remove("fa-eye")
      eyeNew.classList.add("fa-eye-slash")
    }
   }

   function hideB(){
    var z = document.getElementById("Confirm");
    var eyeConfirm = document.getElementById("eyeConfirm");
    
    if(z.type === "password"){

      z.type = "text";
      eyeConfirm.classList.remove("fa-eye-slash")
      eyeConfirm.classList.add("fa-eye")
      
    }
    else{
      z.type = "password";
      eyeConfirm.classList.remove("fa-eye")
      eyeConfirm.classList.add("fa-eye-slash")
    }

   }

   const[SuccessToast,setSuccessToast] = useState(false);  
   const[ErrToast,setErrToast] = useState(false);  

  return (
    <>
     <>
    <div className='tec-addmain'>
 
       <div className="tec-addgrid-layout">
    <div className="tec-addmain-top">
 
 <p><span id="tectopspan"><span id="TecTitleMain"> PROFILE </span> </span>

 <div className='tec-addmain-back'>
  <Link to="/Kdp Tec"><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i></Link>
  </div></p> 

 {/* <hr></hr> */}
 </div>
    </div> 

     {/* Toast */}
    {SuccessToast? <div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"20%"}}>
    <div id="Tec-success-box">
    <div className="Tec-Toastdot"></div>
    <div className="Tec-Toastdot Tec-Toasttwo"></div>
    <div className="Tec-Toastface">
      <div className="Tec-Toasteye"></div>
      <div className="Tec-Toasteye Tec-Toastright"></div>
      <div className="Tec-Toastmouth Tec-Toasthappy"></div>
    </div>
    <div className="Tec-Toastshadow scale"></div>
    <div className="Tec-Toastmessage"><h1 class="Tec-Toastalert">Success!</h1><p>Password Changed Successfully</p></div>
   
  </div></div></div></div>:null} 


   {/* Toast */}
  {ErrToast?<div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"32%"}}>
  <div id="Tec-error-box">
    <div class="Tec-Toastdot"></div>
    <div class="Tec-Toastdot Tec-Toasttwo"></div>
    <div class="Tec-Toastface2">
      <div class="Tec-Toasteye"></div>
      <div class="Tec-Toasteye Tec-Toastright"></div>
      <div class="Tec-Toastmouth Tec-Toastsad"></div>
    </div>
    <div class="Tec-Toastshadow Tec-Toastmove"></div>
    <div class="Tec-Toastmessage"><h1 class="Tec-Toastalert">Error!</h1><p>Incorrect Password !</p></div>
    
  </div></div></div></div>:null}  
    {/* <div className="tec-addgrid-layout">
    <div className="tec-addmain-top">
        <div className='tec-addmain-back'>
           <Link to='/Kdptecdashboard '><i class="fa fa-chevron-left" aria-hidden="true"></i></Link>
        </div> 
           <span>Profile</span>
 

     </div>
 </div> */}
 
 <div>
       <div className="modal-dialog" role="document">
          <div className="modal-content">

           


      
            <form >
              <div className="modal-body mx-3">
                  <div className="md-form mb-5">
         
                  <span type="text" className="form-control validate"   id="name" readOnly/>
                     
                  </div>

                  <div className="md-form mb-5">
          
                  <span type="email"  className="form-control validate"  id="email" readOnly />
         
                  </div>

                  
                </div>
      
                  <div className="modal-footer d-flex justify-content-center">
                        <button className="tec-profile-button" onClick={Changeformopen} >Change Password</button>
                  </div>

           </form>



          </div>
     </div>
</div>



<div className="tec-profile-fade" id="modalRegisterForm" tabindex="-1" role="dialog"
  aria-hidden="true">
       <div className="modal-dialog" role="document">
          <div className="modal-content" style={{marginTop:"150px"}}>

            <div className="modal-header text-center">
                <h4 className="modal-title w-100 font-weight-bold">CHANGE PASSWORD</h4>
                <button type="button" className="close" onClick={changeformclose}>
                <span aria-hidden="true">&times;</span>
                </button>
            </div>


      
            <form onSubmit={handleSubmit} id="tecform">
              <div className="modal-body mx-3">
                  <div className="md-form mb-5">
         
                    <div style={{display:"flex"}}>
                     <input type="Password" className="form-control validate" onKeyUp={handlechange} placeholder='Current Password' id="CurrentPassword"/>
                     <span className='tec-profile-eyeicon'> <i class="fa fa-eye-slash" aria-hidden="true" onClick={hide} id="eyeCurrent"></i></span>
                    
        
                     </div>
                     <span  className='error' id="CurrentErr"></span>
                     <span  className='error' id="CurrentErrA"></span>
                  </div>

                  <div className="md-form mb-5">
                  <div style={{display:"flex"}}>
                      <input type="Password"  className="form-control validate"onKeyUp={handlechange} placeholder='New Password'id="NewPassword"  />
                      <span className='tec-profile-eyeicon'> <i class="fa fa-eye-slash" aria-hidden="true" onClick={hideA} id="eyeNew"></i></span>
                     
         
                     </div>
                     <span className='error' id="NewErr"></span>
                     <span className='error' id="NewErrA"></span>
                     <span className='error' id="NewErrB"></span>
                  </div>

                  <div className="md-form mb-5">
          
                  <div style={{display:"flex"}}>
                      <input type="Password" className="form-control validate" onKeyUp={handlechange}  placeholder='Confirm Password'  id="Confirm"/>
                      <span className='tec-profile-eyeicon'> <i class="fa fa-eye-slash" aria-hidden="true" onClick={hideB} id="eyeConfirm"></i></span>
                    
         
                  </div>
                  <span className='error' id="ConfirmErr"></span>
                     <span  className='error' id="ConfirmErrA"></span>
                  </div>   

                </div>
      
                  <div className="modal-footer d-flex justify-content-center">
                        <button className="tec-adduser-button" >Submit</button>
                  </div>

             </form>



          </div>
     </div>
</div>

 
 </div>
 </>
   
     
        
      </>
  )
}
 
export default TecProfilemain
